import { render, staticRenderFns } from "./MobileAppView.vue?vue&type=template&id=60c8ff0a&scoped=true"
import script from "./MobileAppView.vue?vue&type=script&lang=js"
export * from "./MobileAppView.vue?vue&type=script&lang=js"
import style0 from "./MobileAppView.vue?vue&type=style&index=0&id=60c8ff0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c8ff0a",
  null
  
)

export default component.exports